import { getRegisterFunction } from '../../utils/register.js';
import { OneUxLabelElement } from './OneUxLabelElement.js';
export const register = getRegisterFunction(OneUxLabelElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-label': OneUxLabelElement;
    "label-8e0a7162b8f947004ae9b176fad59dcb": OneUxLabelElement;
  }
}